<template>
  <v-layout class="align-center layout px-4 pt-4 app--page-header">
    <div class="page-header-left">
      <h3
        class="pr-3"
        style="font-weight: 300; font-size: 24px;"
      >
        {{ $vuetify.lang.t('$vuetify.menu.' + $route.meta.title) || "" }}
      </h3>
    </div>

    <v-btn
      class="d-none d-md-block"
      icon
      color="primary"
      @click="goHome"
    >
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-breadcrumbs
      class="d-none d-md-block"
      divider="/"
      :items="breadcrumbs"
    />

    <v-spacer></v-spacer>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      title: "Home",
    }
  },
  computed: {
    breadcrumbs() {
      const { matched } = this.$route
      return matched.map((route, index) => {
        const to =
          index === matched.length - 1
            ? this.$route.path
            : route.path || route.redirect
        const text = this.$vuetify.lang.t('$vuetify.menu.' + route.meta.title)
        return {
          text: text,
          to: to,
          exact: true,
          disabled: false
        }
      })
    }
  },
  methods: {
    goHome() {
      this.$router.push('/dashboard');
    }
  }
}
</script>

<style lang="sass" scoped>
.disabled
  color: grey
  pointer-events: none
  text-decoration: blink
</style>
